import { Badge } from "@mantine/core";
import { useInViewport } from "@mantine/hooks";
import { useEffect } from "react";
import { useStopwatch } from "react-timer-hook";

import { useSession } from "@/hooks/@custom/useSession";
import { useAppDispatch } from "@/store";
import { QueueCompany, useGetSettingsByCompanyQuery } from "@/store/apis/nextcargo";
import { toleranceSliceActions } from "@/store/slices";
import { cn } from "@/utils/cn";
import { getToleranceTime } from "@/utils/getToleranceTime";

export function ToleranceBadge({ queue }: { queue?: QueueCompany }) {
  const { expedition } = useSession();
  const companyId = expedition?.company.id;
  const { data: settings } = useGetSettingsByCompanyQuery({ id: companyId! }, { skip: !companyId });
  const dispatch = useAppDispatch();

  const { ref, inViewport } = useInViewport();
  const { start, pause, reset } = useStopwatch();

  const { time, isExhausted, isInTolerance } = getToleranceTime({ currentData: queue?.date, toleranceTime: settings?.tolerance });

  useEffect(() => {
    if (!companyId || !queue?.id) return;

    dispatch(
      toleranceSliceActions.setQueueTolerance({
        companyId,
        queueId: queue.id,
        isInTolerance
      })
    );
  }, [companyId, dispatch, isInTolerance, queue?.id]);

  useEffect(() => {
    if (inViewport) {
      start();
    }
    if (!inViewport) {
      pause();
    }

    if (isExhausted) {
      pause();
    }

    return reset;
  }, [inViewport]);

  if (!isInTolerance && !isExhausted) return null;

  return (
    <Badge color="yellow.6" radius="sm" c="white" classNames={{ label: cn("font-semibold! capitalize!") }} ref={ref}>
      Tolerância • {time}
    </Badge>
  );
}
